import { CommodityTypesListRequest, CommodityTypeSummary } from '../../models';
import { Service } from './Service';

export abstract class IUtilsService extends Service {
  abstract getCommodityTypes(
    requestData: CommodityTypesListRequest
  ): Promise<CommodityTypeSummary[]>;
}
